import TrainerDetailsModal from './TrainerDetailsModal.jsx';

export default TrainerDetailsModal;
